var __TEMP__ = require('./escape.js');var escape = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_reEscape.js');var reEscape = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_reEvaluate.js');var reEvaluate = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_reInterpolate.js');var reInterpolate = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape }
  }
};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = templateSettings;
